import styled from 'styled-components';

export const RouteHd = styled.div`
  font-size: 1.8rem;
`;

export const Link = styled.div`
  a {
    outline: none;
    text-decoration: none;
    color: #2c67b3;
  }
  a:hover {
    color: #f46913;
  }
`;

export const CityLinksWrp = styled(Link)`
  padding: ${props => props.theme.spacing.custom(10)} 0;
`;

export const CityLink = styled.a`
  padding-bottom: ${props => props.theme.spacing.custom(10)};
  a {
    outline: none;
    text-decoration: none;
    color: #2c67b3;
  }
  a:hover {
    color: #f46913;
  }
`;

export const FlightFareChart = styled.div`
  border-radius: 6px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e6e6e6;
  padding: ${props => props.theme.spacing.custom(10)};
  margin: ${props => props.theme.spacing.custom(10)} 0;
  background-color: #ffffff;
`;

export const FlightsRoute = styled(Link)`
  @media (max-width: 768px) {
    & {
      padding: 0 1rem;
    }
  }
  width: 100%;
`;
